import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadWasteReadingsSuccess(wasteReadings) {
  return { type: types.LOAD_WASTE_WATER_READINGS_SUCCESS, wasteReadings };
}

export function createWasteReadingSuccess(wasteReading) {
  return { type: types.CREATE_WASTE_WATER_READING_SUCCESS, wasteReading };
}

export function updateWasteReadingSuccess(wasteReading) {
  return { type: types.UPDATE_WASTE_WATER_READING_SUCCESS, wasteReading };
}

export function deleteWasteReadingSuccess(wasteReading) {
  return { type: types.DELETE_WASTE_WATER_READING_SUCCESS, wasteReading };
}

export function loadWasteReadings(siteId) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'readings/waste/sites/' + siteId;
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadWasteReadingsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveWasteReading(wasteReading) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'readings/waste';

    if (wasteReading.id) {
      url = baseApi + 'readings/waste/' + wasteReading.id;
      return axios
        .put(url, {
          ...wasteReading,
        })
        .then((response) => {
          dispatch(updateWasteReadingSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          siteId: wasteReading.siteId,
          timestamp: wasteReading.timestamp,
          masterReading: wasteReading.masterReading || null,
          phIn: wasteReading.phIn,
          tempIn: wasteReading.tempIn,
          phOut: wasteReading.phOut,
          bioOxyDemand: wasteReading.bioOxyDemand,
          chlorineResidual: wasteReading.chlorineResidual,
          phosphorous: wasteReading.phosphorous,
          disolvedOxygen: wasteReading.disolvedOxygen,
          dechlorination: wasteReading.dechlorination,
          sludgeLevel: wasteReading.sludgeLevel,
          tempOut: wasteReading.tempOut,
          precipitation: wasteReading.precipitation,
          weather: wasteReading.weather,
          comments: wasteReading.comments,
          userId: wasteReading.userId,
        })
        .then((response) => {
          dispatch(createWasteReadingSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteWasteReading(wasteReading) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'readings/waste/' + wasteReading.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteWasteReadingSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/wasteReadingActions.js